import { Col, Progress, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { HIS_UPLOAD_STATUS, NEW_UPLOAD_STATUS } from '../../../constants/crmConstants';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';
import { getColor, getTotalSizeInMB } from '../../../../modules/crm/inPatient/service/crmUtils';

const FileCount = ({ fileCount, fileLimit, uploadedFiles, showPreviouslyAddedFiles,
  hisUploadedFiles, selectedValue, hisFileSize, selectedFiles, payerWiseFileSize }: any): ReactElement | null => {
  const { uploadedFiles: fileList, selectedHISFiles } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { payerList: { payer } } = useSelector((state: RootState): any => state);
  const [hisSelectedFileSizeInMB, setHisSelectedFileSizeInMB] = useState(0);
  const [avlSelectedFileSizeInMB, setAvlSelectedFileSizeInMB] = useState(0);
  const [totalSize, setTotalSize] = useState(0);
  const totalSizeInMBs = Math?.round(fileCount * fileLimit);
  const formattedPayerWiseFileSize = Math.round(payerWiseFileSize);
  let filesGroupByStatus = fileList?.reduce((result: any, currentElement: any): any => {
    result[currentElement?.claimStatus] = [...result[currentElement?.claimStatus] || [], currentElement];
    return result;
  }, {});

  if (!showPreviouslyAddedFiles && filesGroupByStatus) {
    filesGroupByStatus = filesGroupByStatus[NEW_UPLOAD_STATUS] ? { [NEW_UPLOAD_STATUS]: filesGroupByStatus[NEW_UPLOAD_STATUS] } : {};
  }

  if (filesGroupByStatus?.[NEW_UPLOAD_STATUS]) {
    const temp = filesGroupByStatus[NEW_UPLOAD_STATUS];
    delete filesGroupByStatus[NEW_UPLOAD_STATUS];
    filesGroupByStatus = {
      [NEW_UPLOAD_STATUS]: temp,
      ...filesGroupByStatus,
    };
  }

  const hisFileUploads = fileList?.filter((fileUid: any): any => fileUid?.claimStatus === HIS_UPLOAD_STATUS);
  const newFileUploads = fileList?.filter((fileUid: any): any => fileUid?.claimStatus === NEW_UPLOAD_STATUS);

  // for calculationg the size of HIS selected files
  let hisFileSizeInMB = 0;
  let existingFileSizeInMB = 0;
  useEffect((): any => {
    setTimeout((): any => {
      hisFileSizeInMB = hisFileUploads?.reduce((sum: number, file: any): any => {
        return sum + (file?.size || 0);
      }, 0);
      setHisSelectedFileSizeInMB(hisFileSizeInMB);
    }, 500);
  }, [selectedHISFiles, fileList, hisFileUploads]);

  useEffect((): any => {
    setTimeout((): any => {
      existingFileSizeInMB = selectedFiles?.reduce((sum: number, file: any): any => {
        return sum + (file?.size || 0);
      }, 0);
      setAvlSelectedFileSizeInMB(existingFileSizeInMB);
    }, 500);
  }, [selectedFiles, fileList]);

  useEffect((): any => {
    const avlFileSize = getTotalSizeInMB(filesGroupByStatus?.[NEW_UPLOAD_STATUS], hisSelectedFileSizeInMB, avlSelectedFileSizeInMB);
    setTotalSize(avlFileSize);
  }, [hisSelectedFileSizeInMB, fileList, avlSelectedFileSizeInMB]);

  const totalUploadedFiles = newFileUploads?.length + hisFileUploads?.length + selectedFiles?.length;

  return (
    <><Row className={`${filesGroupByStatus?.[NEW_UPLOAD_STATUS]?.length > 0 ? 'his-file-content' : 'his-file-list-content'} file-container-His file-container text-center his-justify-space-between
         ${(hisFileUploads?.length > 0 && newFileUploads?.length === 0) ? 'his-file-count-width-69' : 'his-file-count-width'} ${payer?.isRpaPayer ? 'file-count-top-10-RPA' : 'file-count-top-10'}`}>
      <Col md={4} className="file-Icon padding-marging"><span className="filecount">{fileLimit}MB
      </span> <span className="fileMB"> / file</span>
      </Col><Col md={6} className="file-Icon padding-marging padding-marging-4"><span className="uploaded-files-docket">
        {(totalUploadedFiles || 0)}
        {fileCount ? (
          <>
            /<span className="total-size-docket">{fileCount}</span>
          </>
        ) : ''}
      </span> <span className="uploaded-count"> files uploaded</span>
      </Col>
      <Col md={13}>
        <Row className="file-Icon-1 his-row-docket-cont padding-marging his-file-count-width-55">
          <Col md={3} className="progress-bar file-container-His his-pl-5">
            <Progress type="circle"
              percent={(totalSize / (formattedPayerWiseFileSize ? formattedPayerWiseFileSize : totalSizeInMBs)) * 100}
              strokeColor={getColor(totalSize, totalSizeInMBs)}
              strokeWidth={10} width={30}
              trailColor="#D4D6E2"
              format={(percent: any): any => (
                <span className={`file-size-porogres-text ${totalSize
                  < totalSizeInMBs ?
                  'progress-level-text-6' : 'progress-level-text-8'}`}>
                  {isNaN(totalSize) ? 0 :
                    totalSize}MB
                </span>
              )} />
          </Col>
          <Col md={7}>
            <span className="total-files-docket">
              {`${isNaN(totalSize) ? 0 : totalSize}`} / <span
                className="total-size-docket">{formattedPayerWiseFileSize ? formattedPayerWiseFileSize : totalSizeInMBs}{`MB`}</span></span>
          </Col>
          <Col md={14}>
            <span className="total-files-docket-limit">
              Claim Docket Limit Remaining</span>
          </Col>
        </Row>
      </Col>
    </Row>
    </>
  );
};
export default FileCount;
